import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
  areAllClassesSelectedSelector,
  setAcademyTopicsSelected,
} from 'features/classCreation';
import CheckboxInput from 'components/CheckboxInput';

function SelectAllClasses() {
  const areAllSelected = useSelector(areAllClassesSelectedSelector);
  const dispatch = useDispatch();

  const handleChange = useCallback(
    (event) => {
      dispatch(setAcademyTopicsSelected({ selected: event.target.checked }));
    },
    [dispatch]
  );

  return (
    <CheckboxInput
      checked={areAllSelected}
      className="full-width"
      onChange={handleChange}
    >
      Select All
    </CheckboxInput>
  );
}

export default SelectAllClasses;
